import React, { useContext, useState, useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import { GlobalContext } from "../../context/GlobalContext";
import Swal from "sweetalert2";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { Button, Modal } from "react-bootstrap";
import { FaPencilAlt, FaTrash } from "react-icons/fa";
import { BsFillPlusCircleFill } from "react-icons/bs";

const DataGambar = () => {
  let navigate = useNavigate();
  const { id } = useParams();
  const [filtered, setFiltered] = useState([]);
  const [loading, setLoading] = useState(false);
  const [smallLoading, setSmallLLoading] = useState(false);
  const [imgArr, setImgArr] = useState([]);
  const [imgPublicID, setImgPublicID] = useState([]);
  const [img, setImg] = useState();
  const [imgPreview, setImgPreview] = useState();
  const { contextState, contextFunctions } = useContext(GlobalContext);
  const { setFetchStatus, fetchStatus } = contextState;
  const [tempIndex, setTempIndex] = useState();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalImgOpen, setIsModalImgOpen] = useState(false);
  const [isModalAddImgOpen, setIsModalAddImgOpen] = useState(false);

  const [largerImg, setLargerImg] = useState();
  const handleEditImg = (i) => {
    setTempIndex(i);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setImg(null);
    setImgPreview(null);
    setIsModalOpen(false);
  };

  const handleItemClick = (item) => {
    setLargerImg(item);
    setIsModalImgOpen(true);
  };

  const handleAddImg = () => {
    setIsModalAddImgOpen(true);
  };

  const handleCloseModalAddImg = () => {
    setImg(null);
    setImgPreview(null);
    setIsModalAddImgOpen(false);
  };

  const handleCloseModalImg = () => {
    setIsModalImgOpen(false);
  };

  const onImgChange = (e) => {
    setImg(e.target.files[0]);
    setImgPreview(URL.createObjectURL(e.target.files[0]));
  };

  const handleSubmitAddImg = async (event) => {
    event.preventDefault();
    const formData = new FormData();
    formData.append("img", img);
    if (img === undefined) {
      Swal.fire({
        title: `Error!`,
        text: `Pilih gambar terlebih dahulu`,
        icon: "error",
        confirmButtonText: "OK",
        allowOutsideClick: false,
      });
    } else {
      setSmallLLoading(true);
      const uploadedImg = await axios.post(
        `https://productspec.cyclic.app/product/oneImgUpload`,
        formData,
        {
          headers: {
            "Content-type": "multipart/form-data",
          },
        }
      );
      const tempUrl = uploadedImg.data.url;
      const tempPublicId = uploadedImg.data.public_id;
      imgArr.push(tempUrl);
      imgPublicID.push(tempPublicId);

      const updateOneImg = await axios.put(
        `https://productspec.cyclic.app/product/updateOneImg/${id}`,
        {
          img: imgArr,
          imgPublicID: imgPublicID,
        }
      );
      setSmallLLoading(false);
      if (updateOneImg.status === 200) {
        handleCloseModalAddImg();
      }
    }
  };

  const handleSubmitImg = async (event) => {
    event.preventDefault();
    const imgToDelete = imgPublicID[tempIndex];
    const formData = new FormData();
    formData.append("img", img);
    if (img === undefined) {
      Swal.fire({
        title: `Error!`,
        text: `Pilih gambar terlebih dahulu`,
        icon: "error",
        confirmButtonText: "OK",
        allowOutsideClick: false,
      });
    } else {
      setSmallLLoading(true);
      const uploadedImg = await axios.post(
        `https://productspec.cyclic.app/product/oneImgUpload`,
        formData,
        {
          headers: {
            "Content-type": "multipart/form-data",
          },
        }
      );
      await axios.post(
        `https://productspec.cyclic.app/product/imgDelCloudinary`,
        {
          publicID: imgToDelete,
        }
      );
      const tempUrl = uploadedImg.data.url;
      const tempPublicId = uploadedImg.data.public_id;
      imgPublicID.splice(tempIndex, 1, tempPublicId);
      imgArr.splice(tempIndex, 1, tempUrl);
      const updateOneImg = await axios.put(
        `https://productspec.cyclic.app/product/updateOneImg/${id}`,
        {
          img: imgArr,
          imgPublicID: imgPublicID,
        }
      );
      setSmallLLoading(false);
      if (updateOneImg.status === 200) {
        handleCloseModal();
      }
    }
  };

  const swalWithBootstrapButtons = Swal.mixin({
    customClass: {
      confirmButton: "btn btn-success",
      cancelButton: "btn btn-danger",
    },
    buttonsStyling: false,
  });

  const handleDeleteImg = async (i) => {
    Swal.fire({
      title: `Hapus Gambar Produk?`,
      text: `Yakin ingin hapus?`,
      icon: "warning",
      confirmButtonText: "Ya",
      showCancelButton: true,
      reverseButtons: true,
      cancelButtonText: "Tidak",
    }).then((result) => {
      if (result.isConfirmed) {
        imgArr.splice(i, 1);
        const tes = imgPublicID.splice(i, 1);
        axios.post(`https://productspec.cyclic.app/product/imgDelCloudinary`, {
          publicID: tes,
        });
        axios
          .put(
            `https://productspec.cyclic.app/product/deleteProductImg/${id}`,
            {
              img: imgArr,
              imgPublicID: imgPublicID,
            }
          )
          .then((response) => {
            window.location.reload();
          });
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        swalWithBootstrapButtons.fire("Batal", "Batal hapus produk", "error");
      }
    });
  };
  useEffect(() => {
    setLoading(true);
    axios
      .get(`https://productspec.cyclic.app/product/${id}`)
      .then((response) => {
        const res = response.data;
        setFiltered(res);
        setImgArr(res.img);
        setImgPublicID(res.imgPublicID);
        setFetchStatus(false);
        setLoading(false);
      });
  }, []);

  if (loading) {
    return <p className="loading"></p>;
  }
  return (
    <div className="page-add">
      <h2 className="text-center fw-bold">Data Gambar</h2>
      <div className="container">
        <div className="row">
          {imgArr.length !== 0 ? (
            imgArr.map((el, index) => (
              <div className="col-lg-4 col-md-6" key={index}>
                <div className="card product-data-card mt-5">
                  <div className="btn-x">
                    <button
                      className="btn-edit-del"
                      onClick={() => handleEditImg(index)}
                    >
                      <FaPencilAlt />
                    </button>
                    <button
                      className="btn-edit-del"
                      onClick={() => handleDeleteImg(index)}
                    >
                      <FaTrash />
                    </button>
                  </div>
                  <Modal show={isModalOpen} onHide={handleCloseModal} centered>
                    <Modal.Header closeButton>
                      <Modal.Title>
                        Edit Foto Produk {tempIndex + 1}
                      </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                      <form onSubmit={handleSubmitImg}>
                        <input
                          type="file"
                          className="form-control"
                          id="image"
                          onChange={onImgChange}
                          name="image"
                          placeholder="Foto..."
                        />
                        <div className="bg-light mt-3 text-center">
                          {imgPreview ? (
                            <div className="container mt-5">
                              <h3 className="text-center">Image Preview</h3>
                              <figure className="image-figure row">
                                <img
                                  className="image-preview"
                                  src={imgPreview}
                                  alt=""
                                />
                              </figure>
                            </div>
                          ) : (
                            ""
                          )}
                          {smallLoading ? (
                            <button className=" btn mt-3 btn-primary pull-right text-loading">
                              Loading
                            </button>
                          ) : (
                            <button
                              type="submit"
                              className="btn mt-3 btn-primary pull-right"
                            >
                              Edit
                            </button>
                          )}
                        </div>
                      </form>
                    </Modal.Body>
                    <Modal.Footer>
                      <button
                        onClick={handleCloseModal}
                        className="btn btn-secondary"
                      >
                        Close
                      </button>
                    </Modal.Footer>
                  </Modal>
                  <img
                    //   onClick={handleDetail}
                    //   data-item={el._id}
                    src={el}
                    className="card-img-detail"
                    onClick={() => {
                      handleItemClick(el);
                    }}
                    //   alt={el.nama_produk}
                  />
                  <Modal
                    show={isModalImgOpen}
                    dialogClassName="modal-width"
                    onHide={handleCloseModalImg}
                    closeButton
                    size="lg"
                    centered
                  >
                    <Modal.Header closeButton></Modal.Header>
                    <Modal.Body>
                      <img
                        //   onClick={handleDetail}
                        //   data-item={el._id}
                        src={largerImg}
                        className="card-img-larger"

                        //   alt={el.nama_produk}
                      />
                    </Modal.Body>
                  </Modal>
                  {/* <div className="card-body">
                  <p
                    // onClick={handleDetail}
                    data-item={el._id}
                    className="card-text text-center text-link fw-bold fs-5"
                  >
                    {el.nama_produk}
                  </p>
                </div> */}
                </div>
              </div>
            ))
          ) : (
            <p>Tidak ada gambar</p>
          )}
          <div className="col-lg-4 col-md-6">
            <div className="card product-data-card mt-5">
              <div
                className="add-img-container"
                onClick={() => {
                  handleAddImg();
                }}
              >
                <img
                  src="https://t3.ftcdn.net/jpg/02/48/42/64/360_F_248426448_NVKLywWqArG2ADUxDq6QprtIzsF82dMF.jpg"
                  className=""
                  alt=""
                />
                <button className="btn-to-add nostyle-btn">
                  <BsFillPlusCircleFill />
                </button>
              </div>
            </div>
          </div>
          <Modal
            show={isModalAddImgOpen}
            onHide={handleCloseModalAddImg}
            centered
          >
            <Modal.Header closeButton>
              <Modal.Title>Upload Foto Produk</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <form onSubmit={handleSubmitAddImg}>
                <input
                  type="file"
                  className="form-control"
                  id="image"
                  onChange={onImgChange}
                  name="image"
                  placeholder="Foto..."
                />
                <div className="bg-light mt-3 text-center ">
                  {imgPreview ? (
                    <div className="container mt-5 img-preview">
                      <h3 className="text-center">Image Preview</h3>
                      <figure className="image-figure row">
                        <img
                          className="image-preview"
                          src={imgPreview}
                          alt=""
                        />
                      </figure>
                    </div>
                  ) : (
                    ""
                  )}
                  {smallLoading ? (
                    <button className=" btn mt-3 btn-primary pull-right text-loading">
                      Loading
                    </button>
                  ) : (
                    <button
                      type="submit"
                      className="btn mt-3 btn-primary pull-right"
                    >
                      Upload gambar
                    </button>
                  )}
                </div>
              </form>
            </Modal.Body>
            <Modal.Footer>
              <button
                onClick={handleCloseModalAddImg}
                className="btn btn-secondary"
              >
                Close
              </button>
            </Modal.Footer>
          </Modal>
        </div>
      </div>
    </div>
  );
};

export default DataGambar;
